import { render, staticRenderFns } from "./PhoneInput.vue?vue&type=template&id=d8daf5ca&"
import script from "./PhoneInput.vue?vue&type=script&lang=js&"
export * from "./PhoneInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports